import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/site";

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const timer = setInterval(() => setIndex((i) => (i + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(timer);
  }, [paused]);

  const current = TESTIMONIALS[index];

  return (
    <section
      className="py-24 md:py-32 bg-sand border-y border-navy/10"
      data-testid="testimonials-section"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="max-w-[1000px] mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <Eyebrow>Client Words</Eyebrow>
          <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-navy text-balance">
            Trusted by clients <em className="italic text-gold-hover">around the world.</em>
          </h2>
        </Reveal>

        <div className="relative min-h-[220px] md:min-h-[190px] mt-12 flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.figure
              key={index}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid="testimonial-card"
            >
              <blockquote className="font-serif italic font-light text-navy text-2xl md:text-3xl lg:text-4xl leading-snug text-balance">
                “{current.quote}”
              </blockquote>
              <figcaption className="mt-6">
                <span className="block text-sm font-bold uppercase tracking-[0.2em] text-navy" data-testid="testimonial-name">
                  {current.name}
                </span>
                {current.location && (
                  <span className="block text-xs uppercase tracking-[0.2em] text-gold-hover mt-1">
                    {current.location}
                  </span>
                )}
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>

        {TESTIMONIALS.length > 1 && (
          <div className="flex justify-center gap-3 mt-10">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                data-testid={`testimonial-dot-${i}`}
                aria-label={`Show testimonial ${i + 1}`}
                onClick={() => setIndex(i)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  i === index ? "w-8 bg-gold" : "w-2 bg-navy/25 hover:bg-navy/50"
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
